import * as THREE from "three";
import VantaBase from "./_base.js";

export default class ShaderBase extends VantaBase {
  init() {
    this.uniforms = {
      iTime: { value: 0 },
      iResolution: { value: new THREE.Vector2(1, 1) },
      iDpr: { value: this.pixelRatio },
      iMouse: { value: new THREE.Vector2() },
      vantaAlpha: { value: this.options.backgroundAlpha },
      vantaBackground: { value: new THREE.Color(this.options.backgroundColor) },
    };
    this.onInit?.();
    if (this.fragmentShader) this.initBasicShader();
  }
  initBasicShader(
    fragmentShader = this.fragmentShader,
    vertexShader = this.vertexShader,
  ) {
    this.updateUniforms();
    // Legacy fragment effects paint an opaque scene. Derive foreground coverage
    // relative to their background for optional compositing onto host backgrounds.
    const last = fragmentShader.lastIndexOf("}");
    fragmentShader =
      "uniform float vantaAlpha;\nuniform vec3 vantaBackground;\n" +
      fragmentShader.slice(0, last) +
      "\n gl_FragColor.a = mix(clamp(length(gl_FragColor.rgb-vantaBackground)*1.5,0.0,1.0),1.0,vantaAlpha);\n" +
      fragmentShader.slice(last);
    const material = new THREE.ShaderMaterial({
      uniforms: this.uniforms,
      vertexShader:
        vertexShader || "void main(){gl_Position=vec4(position,1.0);}",
      fragmentShader,
      transparent: true,
      depthTest: false,
      depthWrite: false,
    });
    this.scene.add(new THREE.Mesh(new THREE.PlaneGeometry(2, 2), material));
    this.camera = new THREE.Camera();
    this.camera.position.z = 1;
  }
  updateUniforms() {
    if (!this.uniforms) return;
    for (const [key, value] of Object.entries(this.options)) {
      if (/^(?:.*Color|color[0-9]*)$/i.test(key)) {
        if (this.uniforms[key]?.value?.isColor)
          this.uniforms[key].value.set(value);
        else this.uniforms[key] = { value: new THREE.Color(value) };
      } else if (typeof value === "number") {
        if (this.uniforms[key]) this.uniforms[key].value = value;
        else this.uniforms[key] = { value };
      }
    }
    this.uniforms.vantaAlpha.value = this.options.backgroundAlpha;
    this.uniforms.vantaBackground.value.set(this.options.backgroundColor);
  }
  resize() {
    super.resize();
    this.uniforms?.iResolution.value.set(
      this.width * this.pixelRatio,
      this.height * this.pixelRatio,
    );
    if (this.uniforms) this.uniforms.iDpr.value = this.pixelRatio;
    return this;
  }
}
